import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { EXAM_URLS } from "../../api/AdminUrls";
import { motion } from "framer-motion";
import "./exam.scss"; // Import SCSS
import StarRating from "./startRating";
import { post } from "../../services/smartApiService";

const Results = () => {
  const [content, setContentRating] = useState<number>(0);
  const [practical, setPracticalRating] = useState<number>(0);
  const [assessment, setAssessmentRating] = useState<number>(0);
  const { state } = useLocation();
  // console.log("state entry", state);
  const navigate = useNavigate();

  const submitFeedback = () => {
    if (content === 0 || assessment === 0) {
      alert("Please submit Feedback before proceeding!");
      return;
    }

    let payload = { content, practical, assessment };
    post(EXAM_URLS.SUBMIT_FEEDBACK, payload).subscribe(() => {
      navigate("/");
    });
  };

  return (
    <motion.div
      className="container results-container"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div
        className="box results-box"
        initial={{ scale: 0.8 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 120 }}
      >
        <h2 className="title">
          🎉{" "}
          {state?.language == "hi"
            ? "भाग लेने के लिए धन्यवाद!"
            : "Thank You for Participating!"}
        </h2>
        <p className="subtitle">
          {state?.language == "hi"
            ? "हम आपके फीडबैक को महत्व देते हैं!"
            : "We value your Feedback!"}
        </p>

        <table>
          <tbody>
            <tr>
              <th>
                📖{" "}
                {state?.language == "hi"
                  ? " सामग्री (सिद्धांत)"
                  : "Content (Theory)"}{" "}
              </th>
              <td>
                <StarRating totalStars={5} onRatingSelect={setContentRating} />
              </td>
            </tr>
            <tr>
              {/* <th>
                🔬{" "}
                {state?.language == "hi"
                  ? "सामग्री (व्यावहारिक)"
                  : "Content (Practicals)!"}
              </th> */}
              {/* <td>
                <StarRating
                  totalStars={5}
                  onRatingSelect={setPracticalRating}
                />
              </td> */}
            </tr>
            <tr>
              <th>
                📊{" "}
                {state?.language == "hi"
                  ? "मूल्यांकन कार्यक्रम"
                  : "Assessment Program"}
              </th>
              <td>
                <StarRating
                  totalStars={5}
                  onRatingSelect={setAssessmentRating}
                />
              </td>
            </tr>
          </tbody>
        </table>

        <motion.button
          className="button is-primary submit-btn"
          onClick={submitFeedback}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          🚀 Submit Feedback
        </motion.button>
      </motion.div>
    </motion.div>
  );
};

export default Results;
